<div class="item-dialog" [ngClass]="{ closed: !opened, opened: opened }" (click)="!character && close()">
  @if (!character) {
    <ghs-item [item]="item" [flipped]="opened" [editionLabel]="gameManager.currentEdition()"></ghs-item>
  }
  @if (!!character) {
    <ghs-character-item [character]="character" [item]="item" [setup]="setup" [flipped]="opened" [dialog]="true"></ghs-character-item>
  }
  @if (!!character) {
    <a class="close-dialog" (click)="close()"></a>
  }
</div>
<div class="close-container" (click)="close()"></div>
